"use client";

export function formatAudioTime(seconds: number | null | undefined): string {
  if (seconds == null || !Number.isFinite(seconds) || seconds < 0) return "--:--";
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, "0")}`;
}

export function buildFallbackWaveform(seedSource: string, bars = 32): number[] {
  let seed = 0;
  for (let i = 0; i < seedSource.length; i++) {
    seed = (seed * 31 + seedSource.charCodeAt(i)) >>> 0;
  }
  const values: number[] = [];
  for (let i = 0; i < bars; i++) {
    seed = (seed * 1664525 + 1013904223) >>> 0;
    const normalized = 0.25 + ((seed % 1000) / 1000) * 0.75;
    values.push(normalized);
  }
  return values;
}

export function normalizeWaveform(
  waveform: number[] | null | undefined,
  seedSource: string,
  bars = 32,
): number[] {
  return waveform && waveform.length > 0
    ? waveform.map((value) => Math.max(0.12, Math.min(1, value / 100)))
    : buildFallbackWaveform(seedSource, bars);
}

export function formatAudioTrackTitle(rawTitle: string | null | undefined): string {
  const fallback = "Аудиосообщение";
  if (!rawTitle) return fallback;

  const trimmed = rawTitle.trim();
  if (!trimmed) return fallback;

  const basename = trimmed.replace(/\.[a-z0-9]{2,5}$/i, "");
  const autogenerated =
    /^(voice|audio|record|recording|memo)[-_]?\d[\w-]*$/i.test(basename) ||
    /^(voice\s*memo|new\s*recording)\b/i.test(basename) ||
    /^\d{10,}$/.test(basename);

  if (autogenerated) {
    return fallback;
  }

  return basename;
}
